import { GetterTree } from 'vuex';
import { ClassroomModel, ClassroomInfo } from '@descomplica/dex-models';
import { ClassroomState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ClassroomState, RootState> = {
  classrooms: (state, classroomGetters) => {
    if (state.classrooms && Object.keys(state.classrooms).length > 0) {
      return Object.values(state.classrooms).map(
        (classroom) => new ClassroomModel(classroom, classroomGetters),
      );
    }
    return [];
  },

  classroomBySlug: (state, classroomGetters) => (classroomSlug: string) => {
    const foundClassroom = Object.values(state.classrooms).find(
      (classroom: ClassroomInfo) => classroom.slug === classroomSlug,
    );

    return foundClassroom && new ClassroomModel(foundClassroom, classroomGetters);
  },

  classroomById: (state, classroomGetters) => (classroomId: number) => {
    const classroom = state.classrooms[classroomId.toString()];

    return classroom ? new ClassroomModel(classroom, classroomGetters) : undefined;
  },

  studentIdsByClassroom: (state) => (classroomId: number) => {
    return state.studentsIds[classroomId] || [];
  },
  isLoadingRevisionLists: (state) => (classroomId: number) => {
    return (
      state.isLoadingRevisionLists[classroomId] ||
      state.isLoadingRevisionLists[classroomId] === undefined
    );
  },
  isLoadingClassroomMaterials: (state) => (classroomId: number) => {
    return (
      state.isLoadingClassroomMaterials[classroomId] ||
      state.isLoadingClassroomMaterials[classroomId] === undefined
    );
  },
  isLoadingClassroomAppointments: (state) => (classroomId: number) => {
    return (
      state.isLoadingClassroomAppointments[classroomId] ||
      state.isLoadingClassroomAppointments[classroomId] === undefined
    );
  },
  isLoadingClassroomData: (state) => {
    return state.isLoadingClassroomData;
  },
  classroomProgressById: (state) => (classroomId: number) => {
    const classroomProgress = state.classroomsProgressMap[classroomId];
    return classroomProgress ? classroomProgress.progress : 0;
  },
  allClassroomsByPeriod: (state) => {
    return state.allClassroomsByPeriod;
  },
  currentClassroomsByPeriod: (state) => {
    return state.currentClassroomsByPeriod;
  },
  currentDefaultClassroomsIdsByPeriod: (state) => {
    const { currentClassroomsByPeriod } = state;

    if (!currentClassroomsByPeriod || !currentClassroomsByPeriod.length) {
      return [];
    }

    return currentClassroomsByPeriod.reduce(
      (classroomsIds: number[], userCurrentClassroom: ClassroomModel) => {
        if (userCurrentClassroom.type === 'default') {
          classroomsIds.push(userCurrentClassroom.id);
        }

        return classroomsIds;
      },
      [],
    );
  },
};

export default getters;
